const FIRST_PAGE = 1;

export default {
  // uses a "load more"
  tasks: {
    // Don't cache separate results based on
    // any of this field's arguments.
    keyArgs: ['order', 'statusFilter', 'workflowFilter', 'searchTerm', 'ownerGroup', 'transition'],
    // add the new items into the existing array
    merge(existing = {}, incoming, { args: { page, perPage } }) {
      if (!existing?.taskUserConnections || page === FIRST_PAGE) {
        return incoming;
      }
      const offset = (page - 1) * perPage;
      // Slicing is necessary because the existing data is
      // immutable, and frozen in development.
      const mergedConnections = existing.taskUserConnections ? existing.taskUserConnections.slice(0) : [];
      const incomingConnections = incoming.taskUserConnections;

      // insert new values into existing cache in the correct indices
      incomingConnections.forEach((incomingTask, index) => {
        mergedConnections[offset + index] = incomingTask;
      });

      return {
        ...incoming,
        taskUserConnections: mergedConnections,
      };
    },
  },
};
